export default "__VITE_ASSET__df776438__"